export default __webpack_public_path__ + "static/media/corner-top-right-big.3af1a0b2.png";